import React from 'react';

const Languages = ({ languages }) => {
  return (
    <div className="bg-white rounded-lg shadow overflow-hidden border border-gray-100">
      <div className="bg-indigo-50 px-6 py-3 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900">Languages</h3>
      </div>
      <div className="px-6 py-4">
        {languages?.items && languages.items.length > 0 ? (
          <div className="space-y-3">
            {languages.items.map((lang, index) => (
              <div key={index} className="flex justify-between items-center border-b border-gray-100 pb-3 last:border-b-0 last:pb-0">
                <span className="text-gray-800 font-medium">{lang.value}</span>
                <span className={`px-3 py-1 text-xs rounded-full font-medium ${
                  lang.proficiency.toLowerCase() === 'native' ? 'bg-green-100 text-green-800' :
                  lang.proficiency.toLowerCase().startsWith('c') ? 'bg-blue-100 text-blue-800' :
                  lang.proficiency.toLowerCase().startsWith('b') ? 'bg-yellow-100 text-yellow-800' :
                  'bg-gray-100 text-gray-800'
                }`}>
                  {lang.proficiency}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500 italic">No languages listed</p>
        )}
      </div>
    </div>
  );
};

export default Languages;
